import { Avatarable } from '@app/components/avatar/avatar.component';
import { ModelMixin } from '../core/base-generic.model';
import { Employee } from '../employee/employee.model';

export class ApplicantIndividualMessage extends ModelMixin<ApplicantIndividualMessage>() {
    protected static _resource = 'applicantTracker/applicantIndividualMessages';
    protected static _version = 'v2';
    protected static _type = 'applicantIndividualMessages';

    protected static _serializeAttributes = ['atsApplicantId', 'isBulk', 'replyTo', 'subject', 'body'];

    get atsApplicantId(): number {
        return this._attributes['atsApplicantId'];
    }

    set atsApplicantId(val: number) {
        this._attributes['atsApplicantId'] = val;
    }

    get isBulk(): boolean {
        return this._attributes['isBulk'];
    }

    set isBulk(val: boolean) {
        this._attributes['isBulk'] = val;
    }

    get emailSentTo(): string {
        return this._attributes['emailSentTo'];
    }

    get replyTo(): string {
        return this._attributes['replyTo'];
    }

    set replyTo(val: string) {
        this._attributes['replyTo'] = val;
    }

    get subject(): string {
        return this._attributes['subject'];
    }

    set subject(val: string) {
        this._attributes['subject'] = val;
    }

    get body(): string {
        return this._attributes['body'];
    }

    set body(val: string) {
        this._attributes['body'] = val;
    }

    get status(): string {
        return this._attributes['status'];
    }

    get employeeId(): number {
        return this._attributes['employeeId'];
    }

    get sender(): Employee | Avatarable {
        if (this.shouldUseNoReply()) {
            const recruiter: Avatarable = {
                firstName: 'NO',
                fullName: this.replyTo,
                lastName: 'REPLY',
            };
            return recruiter;
        }
        return this.hasOne(Employee, 'sender');
    }

    private shouldUseNoReply(): boolean {
        return !this.employeeId;
    }
}
